import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import {
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  InputAdornment,
  IconButton,
  Backdrop,
  Input,
  CircularProgress,
  AppBar,
  Container
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useClientContext } from '../../context/client_context';
import { useAccountingContext } from '../../context/accounting_context';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';
import FileSubsView from '../ssb/FileSubsView';
import FileChangesView from '../ssb/FileChangesView';
import FileProvView from '../ssb/FileProvView';

export default function FilesInfoLookUp() {
  const [index, setIndex] = useState(0);
  const { clientRefId, setClientRefId } = useClientContext();
  const { fileSubList, changeSubList, setChangeSubList, setFileSubList } = useAccountingContext();
  const [memberCode, setMemberCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  useEffect(() => {
    // getMemberInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTabClicked = (event, index) => {
    setIndex(index);
  };

  const Panel = (props) => <div hidden={props.value !== props.index}>{props.children}</div>;

  const getMemberInfo = async (event) => {
    if (memberCode === '') {
      notifyPopup(`No Member # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetMembersByFundNo?medFundNo=${memberCode}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Member not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned parentRef', result.data.result[0]);
          setClientRefId(result.data.result[0].cif_number);
          // getTransactions(result.data.result[0].cif_number);
          getChanges(result.data.result[0].cif_number);
          // setClaimDetailsList([]);
        }
      },
      (error) => {
        notifyPopup(`Error in getMemberInfo!: ${error}`, 'error');
      }
    );
  };

  const getChanges = async (clientRefId) => {
    console.log('returned GetRecordsByClientRefId33', clientRefId);
    const cycleDate = 0;
    await axios(`${baseUrl}/api/ssb/GetChangesByClientRefId?clientRefId=${clientRefId}`).then(
      (result) => {
        console.log('returned GetRecordsByClientRefId', result);
        setChangeSubList(result.data.result);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const getTransactions = async (clientRefId) => {
    const cycleDate = 0;
    await axios(`${baseUrl}/api/ssb/GetRecordsByClientRefId?clientRefId=${clientRefId}`).then(
      (result) => {
        console.log('returned GetRecordsByClientRefId', result);
        setFileSubList(result.data);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid margin={2} container spacing={2} direction="row">
        <Grid item xs={3} sm={3} mr={2}>
          <FormControl>
            <InputLabel htmlFor="memberCodem">Search Member</InputLabel>
            <Input
              id="memberCode"
              type="text"
              value={memberCode}
              onChange={(e) => {
                setMemberCode(e.target.value);
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onMouseDown={handleMouseDownPassword}
                    onClick={() => getMemberInfo()}
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
      </Grid>
      <Card>
        <CardContent>
          <AppBar position="static" color="darkblack">
            <Tabs
              value={index}
              indicatorColor="primary"
              // textColor="white"
              onChange={onTabClicked}
              aria-label="simple tabs example"
            >
              <Tab label="Subscriptions" />
              <Tab label="Prov Subs Old" />
              <Tab label="Changes" />
            </Tabs>
          </AppBar>
          <Box>.</Box>
          <Panel value={index} index={0}>
            {clientRefId > 0 && <FileSubsView />}
          </Panel>
          <Panel value={index} index={1}>
            {clientRefId > 0 && <FileProvView />}
          </Panel>
          <Panel value={index} index={2}>
            {clientRefId > 0 && <FileChangesView />}
          </Panel>
        </CardContent>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Card>
    </Container>
  );
}
